import ResourcesDispatcher from "../config/ResourcesDispatcher";
export default class Resize {
    static resizeCanvas() {
        console.error("CHIAMATO QUA");
        if (window.isFreeSpinEntryPlaying || window.isPickBonusPlaying)
            return;
        const size = window.getGameSize();
        //Cambio le misure della canvas in base all'orientamento
        phaserGame.scale.resize(size.width, size.height);
        let scaleCanvasResult = this.scaleCanvas();
        // centra la canvas nello schermo
        phaserGame.canvas.style.position = 'absolute';
        phaserGame.canvas.style.transform = `scale(${scaleCanvasResult.scale})`;
        phaserGame.canvas.style.transformOrigin = '0 0'; // <— fondamentale!
        phaserGame.canvas.style.left = `${(scaleCanvasResult.viewportWidth - scaleCanvasResult.scaledWidth) / 2}px`;
        phaserGame.canvas.style.top = `${(scaleCanvasResult.viewportHeight - scaleCanvasResult.scaledHeight) / 2}px`;
    }
    // scaling della canvas per adattarla alla finestra (anche in mobile)
    static scaleCanvas() {
        const size = window.getGameSize();
        // leggiamo clientWidth/clientHeight dall'elemento DOM radice invece di usare
        // window/screen/visualViewport. Il clientWidth del documentElement 
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = document.documentElement.clientHeight;
        const windowRatio = viewportWidth / viewportHeight;
        const baseRatio = size.width / size.height;
        let scale;
        if (windowRatio < baseRatio) {
            // finestra più stretta → adatta alla larghezza
            scale = viewportWidth / size.width;
        }
        else {
            // finestra più alta → adatta all’altezza
            scale = viewportHeight / size.height;
        }
        const scaledWidth = size.width * scale;
        const scaledHeight = size.height * scale;
        return { viewportWidth, scaledWidth, viewportHeight, scaledHeight, scale };
    }
    //Quando c'è un resize o un cambio di orientamento, questa funzione si assicura che siano visibili solo i layer corretti in base allo stato attuale
    // e sincronizza la posizione dei pulsanti principali e del pulsante recap, oltre a chiamare le funzioni di sync dei layout specifici di free spin, pick bonus e recap
    // On resize or orientation change, this function ensures that only the correct layers are visible based on the current state
    // and synchronizes the position of the main buttons and the recap button, while calling the sync functions for freespin, pick bonus and recap layouts
    static syncLayoutVisibility(layerBasegame, layerFreeSpin, layerPickBonus) {
        // Durante il recap il layout è sempre basegame, indipendentemente dal gameMode precedente
        // During the recap the layout is always basegame, regardless of the previous gameMode
        const currentGameMode = gameLogicVariableManager.getCurrentGameMode();
        switch (currentGameMode) {
            case ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.FREEGAME:
                layerBasegame.setVisible(false);
                layerFreeSpin.setVisible(true);
                layerPickBonus.setVisible(false);
                animationManager.reparentWinContainers("freespin");
                break;
            case ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.PICKBONUS:
                layerBasegame.setVisible(false);
                layerFreeSpin.setVisible(false);
                layerPickBonus.setVisible(true);
                scene.uiManager.syncMainButtonPosition();
                scene.freeSpinGameArea.syncOrientationLayout();
                scene.pickGameArea.syncOrientationLayout();
                break;
            default:
                layerBasegame.setVisible(true);
                layerFreeSpin.setVisible(false);
                layerPickBonus.setVisible(false);
                animationManager.reparentWinContainers("basegame");
                break;
        }
        scene.uiManager.syncMainButtonPosition();
        scene.freeSpinGameArea.syncOrientationLayout();
        scene.pickGameArea.syncOrientationLayout();
    }
}
